module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-section__column-manage-spacings order-manage-spacings"
  }, [_c('div', {
    staticClass: "content plugin text-plugin"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-container mt-24"
  }, [_c('h2', [_vm._v("Erste Lieferung")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryDay),
      expression: "deliveryDay"
    }],
    staticClass: "selectpicker delivery-selectpicker",
    attrs: {
      "data-container": "body"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deliveryDay = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.validDeliveryDaysMethod()), function(date, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": date
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(date, 'dddd, D. MMMM YYYY')))])
  }), 0)]), _vm._v(" "), _c('results-summary', {
    staticClass: "order-summary__subscription__col-container overview"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-result-block-1__link-container overview order-summary__col-container"
  }, [_c('div', {
    staticClass: "order-cost-summary overview order-cost-summary__col-1"
  }, [_c('div', {
    staticClass: "order-cost-summary__label"
  }, [_vm._v("\n                    Preisübersicht\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "order-cost-summary__price-container"
  }, [_c('div', {
    staticClass: "order-cost-summary__price-total"
  }, [_vm._v("\n                            pro Woche: " + _vm._s(_vm._f("formatPrice")(_vm._f("round")((_vm.mode === 'private' ? _vm.total('all') : _vm.totalPerWeek('all'))))) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-cost-summary__price-details"
  }, [_vm._v("\n                            pro " + _vm._s(_vm.mode === 'business' ? 'Mitarbeiter' : 'Mitbewohner') + " / Woche: " + _vm._s(_vm._f("formatPrice")(_vm._f("round")((_vm.mode === 'private' ? _vm.totalPerPerson('all') : _vm.totalPerPersonPerWeek('all'))))) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-cost-summary__price-details"
  }, [_vm._v("\n                            (inkl. Lieferung / exkl. MwSt. 2.6 %)\n                        ")])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "order-result-block-1__link-info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePriceSummaryModalVisible.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                            Preiszusammenstellung\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('h2', [_vm._v("Adressangaben")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__address__col-container"
  }, [_c('div', {
    staticClass: "order-summary__address__col-1"
  }, [_c('h3', [_vm._v("Lieferadresse")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.deliveryAdress.firstname) + " " + _vm._s(_vm.deliveryAdress.lastname)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.deliveryAdress.company)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.deliveryAdress.additional_shipping)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.deliveryAdress.street)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.deliveryAdress.zip) + " " + _vm._s(_vm.deliveryAdress.city) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__address__col-2"
  }, [_c('h3', [_vm._v("Rechnungsadresse")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.invoiceAdress.firstname) + " " + _vm._s(_vm.invoiceAdress.lastname)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.invoiceAdress.company)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.invoiceAdress.additional_shipping)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.invoiceAdress.street)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.invoiceAdress.zip) + " " + _vm._s(_vm.invoiceAdress.city) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('h2', [_vm._v("Kontaktangaben")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__address__col-container"
  }, [_c('div', {
    staticClass: "order-summary__address__col-1"
  }, [(!_vm.sameInvoiceAddress) ? _c('h2', [_vm._v("Lieferung")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("E-Mail-Adresse:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.deliveryAdress.email_contact))]), _vm._v(" "), _c('h3', [_vm._v("Telefon:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.deliveryAdress.phone))]), _vm._v(" "), _c('h3', [_vm._v("Mobiltelefon:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.deliveryAdress.mobile))])]), _vm._v(" "), (!_vm.sameInvoiceAddress) ? _c('div', {
    staticClass: "order-summary__address__col-2"
  }, [_c('h2', [_vm._v("Rechnung")]), _vm._v(" "), _c('h3', [_vm._v("E-Mail-Adresse:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.invoiceAdress.email_contact))]), _vm._v(" "), _c('h3', [_vm._v("Telefon:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.invoiceAdress.phone))]), _vm._v(" "), _c('h3', [_vm._v("Mobiltelefon:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.invoiceAdress.mobile))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('h2', [_vm._v("Aboangaben")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__address__col-container"
  }, [_c('div', {
    staticClass: "order-summary__address__col-1"
  }, [(_vm.invoiceAdress.additional_billing) ? _c('h3', [_vm._v("Kostenstelle:")]) : _vm._e(), _vm._v(" "), (_vm.invoiceAdress.additional_billing) ? _c('span', [_vm._v(_vm._s(_vm.invoiceAdress.additional_billing))]) : _vm._e(), _vm._v(" "), (_vm.comment) ? _c('h3', [_vm._v("Kommentar:")]) : _vm._e(), _vm._v(" "), (_vm.comment) ? _c('span', [_vm._v(_vm._s(_vm.comment))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Wie hast du uns gefunden?")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.attention_by))])]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__address__col-2"
  }, [(_vm.mode === 'business') ? [_c('h3', [_vm._v("Frühlieferung")]), _vm._v(" "), (_vm.earlyInvoice) ? _c('span', [_vm._v("Ja")]) : _c('span', [_vm._v("Nein")])] : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Rechnung per Post zustellen")]), _vm._v(" "), (_vm.user.invoice_by_post) ? _c('span', [_vm._v("Ja")]) : _c('span', [_vm._v("Nein")])], 2)])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-container"
  }, [_c('h2', [_vm._v("Bestellübersicht")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-714e55ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Checkout/OrderSummary.vue
// module id = 864
// module chunks = 0